/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fancy_Vast_Otter_JumpInputs */

const fr_fancy_vast_otter_jump = /** @type {(inputs: Fancy_Vast_Otter_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semaine`)
};

/**

* @param {Fancy_Vast_Otter_JumpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fancy_vast_otter_jump = /** @type {((inputs?: Fancy_Vast_Otter_JumpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fancy_Vast_Otter_JumpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fancy_vast_otter_jump(inputs)
});